export default "__VITE_ASSET__C899ETxr__"